import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

// import images
import img2 from "../../assets/images/SS4.png";
import img3 from "../../assets/images/SS2.png";
import img4 from "../../assets/images/SS3.png";

class WhatWeDo extends Component {
  render() {
    return (
      <React.Fragment>
        <Container className="mt-100 mt-60">
          <Row className="align-items-center">
            <Col lg="6" md="5">
              <div className="app-feature-shape-left position-relative">
                <div className="text-center text-md-start">
                  <img src={img2} className="img-fluid" alt="" style={{ width: "65%", height: "auto" }} />
                </div>
              </div>
            </Col>

            <Col lg={6} md={7} className="mt-5 mt-sm-0">
              <div className="section-title">
                <h1 className="title mb-3">An Intelligent Way to Manage <br /> Your Cards</h1>
                <p className="para-desc text-muted">DigitCard helps you seamlessly create, customize, and organize your business cards in one digital vault.</p>
                <ul className="list-unstyled text-muted">
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>View, Edit or Delete Cards Easily</li>
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Instantly Accessible Anywhere</li>
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Complete Paper-free Environment</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>

        <Container className="mt-100 mt-60">
          <Row className="align-items-center">
            <Col
              lg="6"
              md={{ size: 7, order: 1 }}
              xs={{ order: 2 }}
              className="mt-5 mt-sm-0"
            >
              <div className="section-title">
                <h1 className="title mb-3">
                  Share Your Cards <br /> Instantly & Securely
                </h1>
                <p className="para-desc text-muted">
                  Instantly share your business cards using secure, unique digital tokens. DigitCard makes networking intuitive and effortless, ensuring you can connect with anyone, anywhere.
                </p>
              </div>
            </Col>

            <Col lg="6" md={{ size: 5, order: 2 }} xs={{ order: 1 }}>
              <div className="app-feature-shape-right position-relative">
                <div className="text-center text-md-end">
                  <img src={img3} className="img-fluid" alt="" style={{ width: "65%", height: "auto" }} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        <Container className="mt-100 mt-60">
          <Row className="align-items-center">
            <Col lg="6" md="5">
              <div className="app-feature-shape-left position-relative">
                <div className="text-center text-md-start">
                  <img src={img4} className="img-fluid" alt="" style={{ width: "65%", height: "auto" }} />
                </div>
              </div>
            </Col>

            <Col lg={6} md={7} className="mt-5 mt-sm-0">
              <div className="section-title">
                <h1 className="title mb-3">Manage Incoming <br /> Card Requests</h1>
                <p className="para-desc text-muted">Effortlessly manage incoming card requests from new contacts with a simple tap. Accept or reject requests to keep your contact list clean.</p>
                <ul className="list-unstyled text-muted">
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Accept/Reject Requests Instantly</li>
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Seamless Request Tracking</li>
                  <li className="mb-1"><span className="text-primary h5 me-2"><i className="uil uil-check-circle align-middle"></i></span>Maintain a Clean Contact Directory</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default WhatWeDo;
